import React from "react";
import styled from "styled-components";
import { C2Text, C3Text } from "../text/CustomText";
import { SizedBox } from "../CommonBaseComponents";
import Translate from "../../translate/Translate";
import { Theme } from "../../Theme";

const PopupOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${Theme.color.black_05};
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const PopupContainer = styled.div`
    background-color: ${Theme.color.white};
    padding: 16px;
    border-radius: 16px;
    box-shadow: 0 4px 12px ${Theme.color.black_015};
    border: 1px solid ${Theme.color.gray200};
    min-width: 300px;
    max-width: 90vw;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
`;

const BaseButton = styled.button`
    padding: 10px 24px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
`;

const CancelButton = styled(BaseButton)`
    background-color: ${Theme.color.white};
    border: 1px solid ${Theme.color.gray200};
    padding: 6px 0;
    width: 60px;

    &:hover {
        background-color: ${Theme.color.stone50};
    }
`;

const ConfirmButton = styled(BaseButton)`
    background-color: ${({ $bgColor }) => $bgColor || Theme.color.indigo500};
    color: ${Theme.color.white};
    padding: 6px 0;
    min-width: 60px;
    padding-left: 16px;
    padding-right: 16px;

    &:hover {
        background-color: ${({ $hoverColor, $bgColor }) => $hoverColor || $bgColor || Theme.color.indigo600};
    }
`;

/**
 * 팝업 컴포넌트
 * @param {boolean} isOpen - 팝업 표시 여부
 * @param {function} onClose - 닫기(취소) 버튼 클릭 시 호출될 함수
 * @param {function} onConfirm - 확인(OK) 버튼 클릭 시 호출될 함수
 * @param {string} message - 팝업 내 메시지
 * @param {string} [confirmText] - 확인 버튼 텍스트 (기본값: common.ok)
 * @param {string} [confirmColor] - 확인 버튼 배경색 (기본값: indigo500)
 * @param {string} [confirmHoverColor] - 확인 버튼 hover 배경색 (기본값: indigo600)
 */
const CustomPopup = ({ isOpen, onClose, onConfirm, message, confirmText, confirmColor, confirmHoverColor }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <PopupOverlay onClick={onClose}>
            <PopupContainer onClick={(e) => e.stopPropagation()}>
                <C2Text fontWeight={"500"}>{message}</C2Text>
                <SizedBox width={"100%"} height={"32px"} />
                <ButtonContainer>
                    {typeof onClose === "function" && (
                        <CancelButton onClick={onClose}>
                            <C3Text fontWeight={"500"}>{Translate("common.cancel")}</C3Text>
                        </CancelButton>
                    )}
                    <ConfirmButton onClick={onConfirm} $bgColor={confirmColor} $hoverColor={confirmHoverColor}>
                        <C3Text fontColor={Theme.color.white} fontWeight={"500"}>
                            {confirmText || Translate("common.ok")}
                        </C3Text>
                    </ConfirmButton>
                </ButtonContainer>
            </PopupContainer>
        </PopupOverlay>
    );
};

export default CustomPopup;
